module.exports = __webpack_public_path__ + "img/Hannah Pabalan.14fb7515.jpg";